import { useState } from 'react';

export default function SecretKeyModal({
  onSubmit,
  onCancel,
  error,
  title = 'Enter edit key',
  description = 'Required to modify order data.',
  submitLabel = 'Continue',
  busy = false,
}) {
  const [key, setKey] = useState('');

  return (
    <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-sm p-6">
        <h3 className="text-sm font-semibold text-gray-900 mb-1">{title}</h3>
        <p className="text-xs text-gray-400 mb-4">{description}</p>
        {error && (
          <div className="bg-red-50 border border-red-200 rounded-lg px-3 py-2 mb-3 text-xs text-red-700">{error}</div>
        )}
        <input
          type="password"
          value={key}
          onChange={(e) => setKey(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && key.trim() && onSubmit(key)}
          placeholder="Secret key"
          autoFocus
          className="w-full px-3 py-2 bg-gray-50 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-400"
        />
        <div className="flex justify-end gap-2 mt-4">
          <button
            onClick={onCancel}
            disabled={busy}
            className="px-3 py-1.5 text-xs text-gray-600 hover:text-gray-800 disabled:opacity-40"
          >
            Cancel
          </button>
          <button
            onClick={() => key.trim() && onSubmit(key)}
            disabled={busy}
            className="px-4 py-1.5 bg-indigo-600 text-white text-xs font-medium rounded-lg hover:bg-indigo-700 disabled:opacity-40"
          >
            {busy ? 'Checking…' : submitLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
